export default __webpack_public_path__ + "static/media/circ3dshell.c6425804.jpg";